<div class="complete-application" (click)="onClickCompleteApplication()">
  <mat-icon class="complete-application__icon">error</mat-icon>
  <p>
    Speed up the application review by securely providing the required information. 
    <span class="complete-application__action">COMPLETE APPLICATION</span>
  </p>
</div>